import { useEffect, useRef, useState } from 'react';
import TextSplit from '../TextSplit/TextSplit';
import './TextVideoSegment.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Box from '@mui/material/Box';
gsap.registerPlugin(ScrollTrigger);

interface TextVideoSegmentProps {
  id: string;
  title: string;
  body: string[];
  video: string;
}

const TextVideoSegment: React.FC<TextVideoSegmentProps> = ({ id, title, body, video }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current === null) return;
    ScrollTrigger.create({
      trigger: videoRef.current!,
      start: "top 50%",
      once: true,
      onEnter: () => {
        videoRef.current!.play();
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  return (
    <Box className="text-video-segment" id={id}>
      <Box className="text-video-text">
        <TextSplit className="text-video-segment-title" id="we-machine-h-4" sx={{ fontSize: { xs: '21px', sm: '30px', md: '39px', lg: '48px' } }}>
          {title}
        </TextSplit>
        <Box className="text-video-segment-body" sx={{ fontSize: { xs: '10px', sm: '15px', md: '19px', lg: '24px' } }}>
          {body.map((b, i) => (
            <TextSplit className="text-video-segment-body-item" key={i} id={`${id}-${i}`}>
              {b}
            </TextSplit>
          ))}
        </Box>
      </Box>
      <Box className="text-video-videos">
        <video
          id={id}
          ref={videoRef}
          src={video}
          className="text-video-video"
          playsInline muted
        />
      </Box>
    </Box>
  );
}

export default TextVideoSegment;